import React, { useRef, useEffect } from 'react'

// https://medium.com/@pdx.lucasm/canvas-with-react-js-32e133c05258
const Canvas = props => {

    const { draw, ...rest } = props
    const canvasRef = useRef(null)

    useEffect(() => {

        const canvas = canvasRef.current
        const context = canvas.getContext('2d')
        let frameCount = 0
        let animationFrameId

        // https://stackoverflow.com/questions/10214873/make-canvas-as-wide-and-as-high-as-parent
        
        // Make it visually fill the positioned parent
        canvas.style.width = '100%';
        canvas.style.height = '100%';

        // ...then set the internal size to match
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        const render = () => {
            frameCount++
            draw(context, frameCount)
            animationFrameId = window.requestAnimationFrame(render)
        }
        render()

        return () => {
            window.cancelAnimationFrame(animationFrameId)
        }
    }, [draw])

    return <canvas ref={canvasRef} {...rest} />
}

export default Canvas